import React from 'react'

const Coe_Committiee = () => {
  return (
    <div>Coe_Committiee</div>
  )
}

export default Coe_Committiee